export default "__VITE_ASSET__81c85fb6__"